<div class="page">
  <div class="customerinformation">
    <div class="customertel">
      <ssg-button icon="icon-chevron_right-o" class="chevron"></ssg-button>
      <button class="telbtn activetel" *ngFor="let call of calls" (click)="answer(call)">
        <div>{{ call.Number }}</div>
        <div class="linenumber">
          <span>{{ call.Line }}</span>
          <i class="icon-call-o telicon"></i>
        </div>
      </button>
      <ssg-button icon="icon-chevron_left-o" class="chevron leftitem"></ssg-button>
    </div>
    <div class="grid" *ngIf="columns?.length > 0" [class.has_callerid]="calls?.length > 0">
      <kgrid
        [class.out-fastacces]="
          !customerOrder.order.saleMethodBranch.IsChangeTheSalesMethod &&
          !customerOrder.order.saleMethodBranch.IsDriverAssignmentFastAccess &&
          !customerOrder.order.saleMethodBranch.IsCustomreFastAccess &&
          !customerOrder.order.saleMethodBranch.IsWaiterFastAccess &&
          !customerOrder.order.saleMethodBranch.IsPagerFastAccess &&
          !customerOrder.order.saleMethodBranch.IsClubFastAccess &&
          !customerOrder.order.saleMethodBranch.IsSalonFastAccess
        "
        class="name"
        *ngIf="isShowGrid"
        #kgrid
        [apiName]="apiName"
        [areaName]="areaName"
        [name]="apiName"
        [isAdd]="false"
        [isEdit]="true"
        [columns]="columns"
        [hasReport]="false"
        [groupable]="false"
        [isDelete]="false"
        [showLoadingMessage]="false"
        defaultSortKey="Number"
        defaultSortKeyKind="asc"
        reportName="Customer"
        pathPreFix="SALE"
        [filters]="currentGridFilter"
        [isMulti]="false"
        [editFromForm]="true"
        (onEdit)="onEdit($event)"
        (onDataStateChanged)="onDataStateChanged($event)"
        (onRowSelected)="getRowSelectedData($event)"
        [disableOnDoubleClick]="true"
        [customExportExcelUrl]="'Customer/ExportExcel'"
        (onGetDataComplete)="onGetDataComplete($event)"
        (onDoubleClick)="onDoubleClick($event)"
        [getParamsForExportExcelWithPostMethod]="getParamsForExportExcelWithPostMethod.bind(this)">
      </kgrid>
    </div>
  </div>
  <div class="customercreat" *ngIf="isShowGrid || !this.customerOrder.common.isMobileMode">
    <ssg-button
      [label]="'ClientApp.FrontOffice.Order.CustomerOrder.CreateNewCustomer' | translate"
      (click)="customerOrder.stateChange()"
      class="newcustomer"
      icon="icon-person_add-F"></ssg-button>
    <ssg-button icon="icon-check-o" class="newcustomer set-Customer" (click)="customerOrder.setCostomerInfo()"></ssg-button>
  </div>
  <div class="customers">
    <order-newcustomer
      class="customer"
      [customerOrder]="customerOrder"
      *ngIf="
        customerOrder.currentCustomerDetailsEnum === customerOrder.customerDetailsEnum.New && (!isShowGrid || !this.customerOrder.common.isMobileMode)
      ">
    </order-newcustomer>
    <order-customerdetails
      class="customerinfodetail"
      *ngIf="customerOrder.currentCustomerDetailsEnum === customerOrder.customerDetailsEnum.Details"
      [customerOrder]="customerOrder">
    </order-customerdetails>
  </div>
</div>
